module.exports = __webpack_public_path__ + "img/logo-waitlist-calculator.96bacf31.svg";